<template>
  <modal v-model="shown" title="Team Report Permissions" :footer="false">
    <p>
      You’re now a member of ‘{{ model.names[0] }}’{{
        model.names.length == 1 ? "" : " and " + (model.names.length - 1) + " other team"
      }}{{ model.names.length > 2 ? "s" : "" }}.
    </p>

    <p>
      Your teammates and team lead will need your permission to view your Solo and Viewpoints
      reports that you create while using Gyre.
    </p>

    <div style="height: 20px"></div>

    <div class="clearfix">
      <div style="float: left; margin-top: 8px">
        <p>
          <big>Allow my team{{ model.names.length > 1 ? "s" : "" }} to see my reports?</big>
        </p>
      </div>

      <div style="float: right">
        <report-permission-control
          :ids="model ? model.ids : []"
          :names="model ? model.names : []"
          @input="handleChoice"
        />
      </div>
    </div>

    <p>You can change this later, in your team's settings.</p>
  </modal>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import axios from "axios";
import { Modal } from "uiv";
import ReportPermissionControl from "./report-permission-control.vue";
import ReportPermissionDialogModel from "./report-permission-dialog-model";

const props = withDefaults(
  defineProps<{
    refreshPageOnChange?: boolean;
  }>(),
  {
    refreshPageOnChange: false,
  },
);

const model = ref<ReportPermissionDialogModel>(new ReportPermissionDialogModel());

const shown = ref(false);

onMounted(() => {
  axios.get("/api/reportpermissions/").then((resp) => {
    const modelValue = resp.data as ReportPermissionDialogModel;
    model.value = modelValue;
    shown.value = model.value && model.value.ids && model.value.ids.length > 0;
  });
});

function open(): void {
  shown.value = true;
}

function close(): void {
  shown.value = false;
}

function handleChoice(): void {
  if (props.refreshPageOnChange) {
    window.location.reload();
  } else {
    close();
  }
}

defineExpose({
  open,
  close,
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less"></style>
